import axios from 'axios';
import { axiosInstance } from '../axios-instance';
import { IQuestion, IQuestionListParams } from './types';
import { IPageResponse } from '@/types/common.types';

export const getLessonQuestions = async (
  params: IQuestionListParams
): Promise<IPageResponse<IQuestion>> => {
  return axiosInstance.get('/questions', {
    params,
  });
};

export const getLessonQuestionById = async (id: string): Promise<IQuestion> => {
  return axiosInstance.get(`/questions/${id}`);
};

export const updateQuestionAnswer = async (
  id: string,
  answer: string
): Promise<void> => {
  return axiosInstance.put(`/questions/${id}/answer`, { answer });
};

export const getQuestionXamlString = async (
  host: string,
  xamlFile: string,
  xamlUrl: string
) => {
  return axios.get(`${host}${xamlFile}${xamlUrl}`, {
    headers: { Accept: ' */*' },
  });
};
